import {writable} from "svelte/store";

// Random way of getting unique values for my 'enums'
const I_MIN = 0;
let I = I_MIN;
const resetI = () => I = I_MIN;
const incrI = () => I++;

resetI();
export const PAGE_ID = {
    LOGIN: incrI(),
    DASHBOARD: incrI(),
    PEOPLE: incrI(),
        VIEW_PERSON: incrI(),
        ADD_PERSON: incrI(),
    COMPANIES: incrI(),
        VIEW_COMPANY: incrI(),
        ADD_COMPANY: incrI(),
    REQUESTS: incrI(),
        VIEW_REQUEST: incrI(),
        ADD_REQUEST: incrI(),
    DEALS: incrI(),
        VIEW_DEAL: incrI(),
        ADD_DEAL: incrI(),
    PROMOTIONS: incrI(),
        VIEW_PROMOTION: incrI(),
        ADD_PROMOTION: incrI(),
        VIEW_SHORTLIST: incrI(),
        ADD_SHORTLIST: incrI(),
    QUICK_ADD: incrI(),
    PLANNER: incrI(),
};
const START_PAGE = PAGE_ID.DASHBOARD;

export let PAGE_DATA = {};
PAGE_DATA[PAGE_ID.LOGIN] = {
    name: 'Login',
    in_menu: false,
};
PAGE_DATA[PAGE_ID.DASHBOARD] = {
    name: 'Dashboard',
    in_menu: true,
};
PAGE_DATA[PAGE_ID.PLANNER] = {
    name: 'Planner',
    in_menu: true,
};
PAGE_DATA[PAGE_ID.PEOPLE] = {
    name: 'People',
    in_menu: true,
};
PAGE_DATA[PAGE_ID.VIEW_PERSON] = {
    name: 'View Person',
    in_menu: false,
};
PAGE_DATA[PAGE_ID.ADD_PERSON] = {
    name: 'Add Person',
    in_menu: false,
};
PAGE_DATA[PAGE_ID.REQUESTS] = {
    name: 'Requests',
    in_menu: true,
};
PAGE_DATA[PAGE_ID.VIEW_REQUEST] = {
    name: 'View Request',
    in_menu: false,
};
PAGE_DATA[PAGE_ID.ADD_REQUEST] = {
    name: 'Add Request',
    in_menu: false,
};
PAGE_DATA[PAGE_ID.COMPANIES] = {
    name: 'Companies',
    in_menu: true,
};
PAGE_DATA[PAGE_ID.VIEW_COMPANY] = {
    name: 'View Company',
    in_menu: false,
};
PAGE_DATA[PAGE_ID.ADD_COMPANY] = {
    name: 'Add Company',
    in_menu: false,
};
PAGE_DATA[PAGE_ID.DEALS] = {
    name: 'Deals',
    in_menu: true,
};
PAGE_DATA[PAGE_ID.VIEW_DEAL] = {
    name: 'View Deal',
    in_menu: false,
};
PAGE_DATA[PAGE_ID.ADD_DEAL] = {
    name: 'Add Deal',
    in_menu: false,
};
// PAGE_DATA[PAGE_ID.PROMOTIONS] = {
//     name: 'Promotions',
//     in_menu: true,
// };
PAGE_DATA[PAGE_ID.VIEW_PROMOTION] = {
    name: 'View Promotion',
    in_menu: false,
};
PAGE_DATA[PAGE_ID.ADD_PROMOTION] = {
    name: 'Add Promotion',
    in_menu: false,
};
PAGE_DATA[PAGE_ID.VIEW_SHORTLIST] = {
    name: 'View Shortlist',
    in_menu: false,
};
PAGE_DATA[PAGE_ID.ADD_SHORTLIST] = {
    name: 'Add Shortlist',
    in_menu: false,
};
PAGE_DATA[PAGE_ID.QUICK_ADD] = {
    name: 'Quick Add',
    in_menu: false,
};


export const router = writable({
    current_page: START_PAGE,
    context: null,
})
let $router = null;
const unsubscribe = router.subscribe(val => $router = val);

export const navigateTo = (page_id, prev_page_id = null) => {
    if(typeof page_id !== 'number') console.warn(`attempting to navigate to a non-numeric page_id: ${page_id}`);
    if(prev_page_id === null) prev_page_id = $router.current_page;
    router.set({
        current_page: page_id,
        context: {
            previous_page_id: prev_page_id
        },
    });
};

export const navigateWithContextTo = (page_id, context_obj, prev_page_id = null) => {
    if(typeof page_id !== 'number') console.warn(`attempting to navigate to a non-numeric page_id: ${page_id}`);
    if(prev_page_id === null) prev_page_id = $router.current_page;
    context_obj.previous_page_id = prev_page_id;
    router.set({
        current_page: page_id,
        context: context_obj,
    });
};


// let $people = null;
// const a_unsubscribe = people.subscribe(val => $people = val);
//
// let $companies = null;
// const b_unsubscribe = companies.subscribe(val => $companies = val);
//
// let $person_company = null;
// const c_unsubscribe = person_company.subscribe(val => $person_company = val);


